// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"27f58a9e","239":"81077617","667":"486159fb"}[chunkId] + ".chunk.js";
};